import { combineReducers } from 'redux';
// Import reducers
import form from './configuraition_form_reducer';

export default combineReducers({
	form
});
